import DataDuck from '@aytm/app/insights/dashboard/duckness/ducks/DataDuck/DataDuck.untyped'
import { DATA_ACTIONS } from '@aytm/app/insights/dashboard/duckness/ducks/DataDuck/DataDuck.actions'
import type { DuckActionPayloadTuple } from '@aytm/app/insights/dashboard/duckness/poolDispatch'
import type { TagsEventType } from '@aytm/app/insights/dashboard/components/hooks/types'

// Initiate first data load
export const makeGetSchemaDataAction = (params?: unknown) =>
  [
    DataDuck.duckName,
    DATA_ACTIONS.GET_SCHEMA,
    {
      timestamp: Date.now(),
      ...(params ? { params } : {})
    }
  ] as DuckActionPayloadTuple<{ timestamp: number } & (typeof params extends undefined ? {} : { params: unknown })>

export const makeRefreshComponentDataAction = ({ refresh }: { refresh: unknown }) =>
  makeGetSchemaDataAction({ refresh })

export const createInitiateLoading = (params?: object) =>
  DataDuck.action[DATA_ACTIONS.GET_SCHEMA]({ params, timestamp: Date.now() })

export const makeBlanketDataAction = (action: string, payload: TagsEventType) =>
  [DataDuck.duckName, action, payload] as DuckActionPayloadTuple<TagsEventType>
